import { createContext, useContext, useMemo, type ReactNode } from "react";
import { createMongoAbility, type RawRuleOf } from "@casl/ability";
import { createContextualCan } from "@casl/react";
import type { AbilityRule } from "@/lib/api/user";
import type { AppAbility } from "./rbac";

const AbilityContext =
  createContext<AppAbility>(createMongoAbility<AppAbility>());

export const Can = createContextualCan(AbilityContext.Consumer);

export function AbilityProvider({
  rules,
  children,
}: {
  rules: AbilityRule[] | undefined;
  children: ReactNode;
}) {
  const ability = useMemo(
    () =>
      createMongoAbility<AppAbility>(
        (rules ?? []) as RawRuleOf<AppAbility>[],
      ),
    [rules],
  );

  return (
    <AbilityContext.Provider value={ability}>
      {children}
    </AbilityContext.Provider>
  );
}

export function useAbility(): AppAbility {
  return useContext(AbilityContext);
}
